import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withToastManager } from 'react-toast-notifications';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Page from '../components/Page';
import Head from '../components/DashboardHead';
import { nsOptions } from '../i18n';
import history from '../history';
import Toast from '../utils/Toast';
import '../assets/css/two-factor.css';

const mapStateToProps = (state) => ({
  user: state.auth.authUser,
});

const mapDispatchToProps = () => ({});

/**
 * Page affichée lorsque l'utilisateur doit configurer le 2FA
 * Cette page bloque l'accès au reste de l'application
 */
@withToastManager
@connect(mapStateToProps, mapDispatchToProps)
@withTranslation('', nsOptions)
class TwoFactorRequired extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    t: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: null,
  };

  constructor(props) {
    super(props);
    // Check if user can skip 2FA setup (false when policy is 'required')
    const canSkipStorage = sessionStorage.getItem('2fa_can_skip');
    const canSkip = canSkipStorage !== 'false';

    this.state = {
      isSkipping: false,
      canSkip,
    };
  }

  handleStartSetup = () => {
    history.push('/dashboard/settings/security/2fa/setup');
  };

  handleSkip = () => {
    const { user, t } = this.props;

    if (!user) return;

    this.setState({ isSkipping: true });

    // Enregistrer dans localStorage que l'utilisateur a choisi de reporter
    localStorage.setItem(`2fa_setup_dismissed_${user.id}`, Date.now().toString());

    Toast.success(this.props, t('twoFactor:required.skip-toast'), 4000);

    // Rediriger vers le dashboard
    setTimeout(() => {
      history.push('/dashboard/home');
    }, 500);
  };

  render() {
    const { t } = this.props;
    const { isSkipping, canSkip } = this.state;

    const title = canSkip
      ? t('twoFactor:required.title-optional')
      : t('twoFactor:required.title-mandatory');
    const subtitle = canSkip
      ? t('twoFactor:required.subtitle-optional')
      : t('twoFactor:required.subtitle-mandatory');

    return (
      <Page
        {...this.props}
        title={title}
        checkAuthorizations={[]}
      >
        <Head
          {...this.props}
          title={title}
        />
        <div className="dashboard-content">
          <div className="container" style={{ maxWidth: '700px', marginTop: '50px' }}>
            <div className="card bg-white card-shadow p-4 p-md-5">
              <div className="text-center mb-4">
                <FontAwesomeIcon
                  icon={['far', 'shield-check']}
                  size="3x"
                  className={canSkip ? 'text-newturquoise-1 mb-3' : 'text-warning mb-3'}
                />
                <h2 className="font-weight-bold mb-2">
                  {title}
                </h2>
                <p className="text-muted">
                  {subtitle}
                </p>
              </div>

              <div className="two-factor-required-content">
                <div className="mb-4">
                  <h5 className="font-weight-semibold mb-3">
                    <FontAwesomeIcon icon={['fas', 'info-circle']} className="mr-2 text-primary" />
                    {t('twoFactor:required.why-enable-title')}
                  </h5>
                  <ul className="text-muted" style={{ lineHeight: '1.8' }}>
                    <li>{t('twoFactor:required.why-benefit-1')}</li>
                    <li>{t('twoFactor:required.why-benefit-2')}</li>
                    <li>{t('twoFactor:required.why-benefit-3')}</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h5 className="font-weight-semibold mb-3">
                    <FontAwesomeIcon icon={['fal', 'key']} className="mr-2 text-primary" />
                    {t('twoFactor:required.how-works-title')}
                  </h5>
                  <p className="text-muted" style={{ lineHeight: '1.8' }}>
                    {t('twoFactor:required.how-works-description')}
                  </p>
                  <p className="text-muted mb-0">
                    <small>
                      <FontAwesomeIcon icon={['fal', 'clock']} className="mr-2" />
                      {t('twoFactor:required.setup-time-short')}
                    </small>
                  </p>
                </div>

                <div className="text-center mt-5">
                  <button
                    type="button"
                    className="btn btn-lg btn-newturquoise-1 mb-3"
                    onClick={this.handleStartSetup}
                    style={{ minWidth: '200px' }}
                  >
                    <FontAwesomeIcon icon={['far', 'shield-check']} className="mr-2" />
                    {t('twoFactor:required.enable-now')}
                  </button>

                  {canSkip && (
                    <div>
                      <button
                        type="button"
                        className="btn btn-link text-muted"
                        onClick={this.handleSkip}
                        disabled={isSkipping}
                      >
                        {isSkipping ? (
                          <>
                            <FontAwesomeIcon icon={['fal', 'spinner']} spin className="mr-2" />
                            {t('twoFactor:required.redirecting')}
                          </>
                        ) : (
                          t('twoFactor:required.skip-for-later')
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

export default TwoFactorRequired;
